/** @type {import("vuex").MutationTree} */
export const mutations = {
  SET_STATE(state, data) {
    Object.assign(state, data);
  }
};

export default mutations;
